import { RouterProvider, createRouter } from '@tanstack/react-router';

import { useAuth } from '@/features/auth/hooks/use-auth';

import { queryClient } from '../utils/query-client';
import { routeTree } from './routeTree.gen';

const router = createRouter({
  routeTree,
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  context: { auth: undefined!, queryClient },
  // defaultPreload: 'intent', // TODO: Enable this when we have a way to preload the data
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export function AppRouter() {
  const auth = useAuth();

  if (auth.isLoading) {
    // TODO: add a loading state
    return (
      <div className="flex items-center justify-center min-h-screen">
        Loading...
      </div>
    );
  }

  return <RouterProvider router={router} context={{ auth }} />;
}
